module.exports = __webpack_public_path__ + "static/media/pricing-section.320ad526.png";